export default {
  // Product page recommendations
  product: {
    currentProduct: null,
    complementaryProducts: [],
    relatedProducts: [],
    crossSellProducts: [],
    showPanelUp: false,
    isFetching: false,
    error: null,

    async fetchRecommendedProducts(productId, limit1 = 10) {
      this.isFetching = true;
      this.error = null;

      if (limit1 > 0 && limit1 <= 10) {
        try {
          const response = await fetch(
            window.Shopify.routes.root +
              'recommendations/products.json?product_id=' +
              productId +
              '&intent=complementary'
          );
          const data = await response.json();
          if (data.products.length > 0) {
            this.complementaryProducts = data.products.slice(0, limit1) || [];
          }
        } catch (error) {
          console.error('Error fetching complementary product:', error);
          this.error = error.message;
        }
      }

      const limit2 = 10 - this.complementaryProducts.length;

      if (limit2 > 0) {
        try {
          const response = await fetch(
            window.Shopify.routes.root +
              'recommendations/products.json?product_id=' +
              productId +
              '&intent=related'
          );
          const data = await response.json();
          if (data.products.length > 0) {
            // remove duplicates that's already in complementaryProducts
            this.relatedProducts = data.products.filter(
              (product) =>
                !this.complementaryProducts.some(
                  (comp) => comp.id === product.id
                )
            );
          }
        } catch (error) {
          console.error('Error fetching related products:', error);
          this.error = error.message;
        }
      }

      this.crossSellProducts = [
        ...this.complementaryProducts,
        ...this.relatedProducts,
      ].slice(0, 10);
      this.isFetching = false;

      // console.log(
      //   `Fetched ${this.complementaryProducts.length} complementary + ${10 - this.complementaryProducts.length} related = ${this.crossSellProducts.length} total products`
      // );
    },
  },

  // Cart recommendations
  cart: {
    cartProducts: [],
    crossSellProducts: [],
    isFetching: false,
    error: null,

    async fetchAllRecommendations(items) {
      const previousCartProducts = this.cartProducts;
      this.cartProducts = items.map((item) => ({
        product_id: item.product_id,
      }));

      this.isFetching = true;
      this.error = null;
      const uniqueProductIds = new Set();
      const allRecommendations = [];

      try {
        // Get unique IDs from current cart
        this.cartProducts.forEach((item) => {
          if (item.product_id) uniqueProductIds.add(item.product_id);
        });

        if (uniqueProductIds.size === 0) {
          console.warn('No product IDs found in cart items');
          return;
        }

        // Get unique IDs from previous cart
        const previousUniqueIds = new Set(
          previousCartProducts
            .filter((item) => item.product_id)
            .map((item) => item.product_id)
        );

        // Check if sets are identical (same size and same members)
        const sameCart =
          uniqueProductIds.size === previousUniqueIds.size &&
          [...uniqueProductIds].every((id) => previousUniqueIds.has(id));

        if (sameCart) {
          // console.log('Cart product ids unchanged, skipping fetch');
          return;
        }

        // Limit to 10 products if needed
        if (uniqueProductIds.size > 10) {
          console.warn('Too many product IDs found, limiting to 10');
          uniqueProductIds = new Set(Array.from(uniqueProductIds).slice(0, 10));
        }

        // Determine max recommendations per product based on cart size
        const cartCount = uniqueProductIds.size;
        let maxPerProduct;
        if (cartCount === 1) {
          maxPerProduct = 15; // Display all it has (up to total limit)
        } else if (cartCount === 2) {
          maxPerProduct = 5; // Max 5 of each
        } else {
          maxPerProduct = 3; // Max 3 of each for 3+ items
        }

        // Continue with fetching recommendations...
        const promises = Array.from(uniqueProductIds).map(async (productId) => {
          const response = await fetch(
            window.Shopify.routes.root +
              'recommendations/products.json?product_id=' +
              productId +
              '&intent=complementary'
          );
          const data = await response.json();
          // Apply max limit per product here
          return (data.products || []).slice(0, maxPerProduct);
        });

        const results = await Promise.all(promises);
        const seenIds = new Set();

        // Merge and deduplicate recommendations, respecting total limit of 15
        results.forEach((products) => {
          products.forEach((product) => {
            if (!seenIds.has(product.id) && allRecommendations.length < 15) {
              allRecommendations.push(product);
              seenIds.add(product.id);
            }
          });
        });

        this.crossSellProducts = allRecommendations;
        // console.log(
        //   `Fetched cart recommendations: ${this.crossSellProducts.length} products (max ${maxPerProduct} per item)`
        // );
      } catch (error) {
        console.error('Error fetching cart recommendations:', error);
        this.error = error.message;
      } finally {
        this.isFetching = false;
      }
    },
  },
};
